require("@rails/ujs").start()
require("turbolinks").start()

// Bootstrap
import "./bootstrap_custom.js"

// Stylesheets
import "./stylesheets/application"

// Stimulus
import "controllers"